// extracted by mini-css-extract-plugin
export default {"wrap":"DishSemiFinishedList_wrap__JKOGQ","noData":"DishSemiFinishedList_noData__Nj35x"};